import { SupportedLocale } from "../language/locale.model";

/** The three text fields an insight carries: title (`s`), body (`m`) and long body (`l`). */
export type InsightTextField = 's' | 'm' | 'l';

export const INSIGHT_TEXT_FIELDS: readonly InsightTextField[] = ['s', 'm', 'l'];

/** Human-facing names for the fields, whose one-letter codes mean nothing to a reader. */
export const INSIGHT_TEXT_FIELD_LABELS: Record<InsightTextField, string> = {
  s: 'Title',
  m: 'Body',
  l: 'Long body',
};

/**
 * Which locales each text field already holds, e.g. `{ s: ['en','de'], m: ['en'], l: [] }`.
 * Each array is an unordered **set** — use `includes()`, never index by position or
 * compare two arrays for equality (the backend stores this as a JSON column, whose key
 * and element order is decided by the storage engine).
 */
export type InsightTranslatedLocales = Record<InsightTextField, SupportedLocale[]>;

export interface InsightBase {

    id: number;
    slug: string;
    /** Title, already resolved to one locale (see `InsightTranslatedLocales` for coverage). */
    s: string | null;
    /**
     * Body, already resolved to one locale. MAY CONTAIN HTML: imported WordPress excerpts
     * arrive `<p>`-wrapped while imported sections are plain text, so the format varies row
     * by row and is expected to change again. Don't hard-code a rendering assumption.
     */
    m: string | null;
    /** Long body, already resolved to one locale. Always null today. */
    l: string | null;
    num: number | null;
    date: Date | null;
    /** Free text on the backend, no enum behind it. Observed: 'cco-assessment-related'. */
    category: string | null;
    /** Free text on the backend, no enum behind it. Observed: 'summary'. */
    type: string | null;
    released_at: Date | null;
    created_at: Date | null;
    updated_at: Date | null;

}
